import { Tooltip } from 'antd'
import styles from './node.module.less'

export enum BasicShape {
  Stream,
  Line,
  Image,
  Text,
}

interface BasicNodeProps {
  component: any
  title: string
  type: BasicShape
}

export function BasicNode(props: BasicNodeProps) {
  const {component, title, type} = props

  const onDragStart = (e: React.DragEvent) => {
    e.dataTransfer.setData('offsetX', String(e.nativeEvent.offsetX))
    e.dataTransfer.setData('offsetY', String(e.nativeEvent.offsetY))
    e.dataTransfer.setData('type', type.toString())
  }

  return <div className={styles.nodeContainer} onDragStart={onDragStart} draggable>
    <Tooltip title={title}>
      {component}
    </Tooltip>
  </div>
}